'use client';

import { Mic } from 'lucide-react';
import { pushEvent, CONVERSION_EVENTS } from '@/lib/analytics/core';
import { tiktokEvent } from '@/components/analytics/TikTokPixel';
import { ELEVENLABS_LIVE_AGENT_IDS } from '@config/elevenlabs';
import TalkToBriModalTrigger from '@/components/voice/TalkToBriModalTrigger';

/**
 * Enterprise card CTA: an amber "Talk to Bri" pill that opens the shared
 * TalkToBriModal wired to the dedicated Enterprise Sales agent. Thin
 * consumer of TalkToBriModalTrigger (Task A3) — this component now owns
 * only the button's own styling + its pre-open analytics.
 */
export function EnterpriseTalkToBri() {
  return (
    <TalkToBriModalTrigger
      source="enterprise_pricing"
      agentId={ELEVENLABS_LIVE_AGENT_IDS.enterprise}
      // Pre-consolidation EnterpriseVoiceModal behavior: no Spark self-serve
      // CTA after the call — enterprise prospects go back into the ring to
      // talk again, since a sales conversation (not a self-serve signup) is
      // the intended next step for this surface.
      postCall={{ mode: 'restart' }}
      helperText={{ idle: 'Tell Bri about your enterprise needs - voice-first, no forms.' }}
    >
      {(open) => (
        <button
          type="button"
          onClick={() => {
            pushEvent(CONVERSION_EVENTS.CHECKOUT_VIEWED, { plan: 'enterprise' });
            tiktokEvent('AddToCart', { content_type: 'product', content_name: 'enterprise' });
            open();
          }}
          data-testid="pricing-enterprise-talk-to-bri"
          aria-haspopup="dialog"
          className="v4-cta-primary v4-tier-cta"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 10,
            fontFamily: 'var(--font-geist-sans)',
            fontWeight: 500,
            fontSize: 16,
            letterSpacing: '-0.01em',
            color: 'var(--ink)',
            background: 'linear-gradient(135deg, var(--amber-glow) 0%, var(--paper) 100%)',
            borderRadius: 999,
            border: '1px solid rgba(255,213,146,0.4)',
            boxShadow: '0 10px 30px -10px rgba(245,165,36,0.55)',
            padding: '18px 34px',
            cursor: 'pointer',
          }}
        >
          <Mic size={18} aria-hidden="true" />
          Talk to Bri
        </button>
      )}
    </TalkToBriModalTrigger>
  );
}

export default EnterpriseTalkToBri;
